import AuthManager from "./components/auth/AuthManager"
import NCSApp from "./NCSApp"

(async () => {
    let user = await AuthManager.initLogin()
    if (user) {
        await NCSApp.init()
    }
})()
